import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../../assets/css/navbar.scss'
import companyLogo from '../../assets/images/signin/logo-dark.png'
import profileImg from '../../assets/images/dashboard/profileImg.jpg'
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ClearBtn, SearchBtn } from '../Buttons/Buttons';
import logOutImg from '../../assets/images/signin/log_out.png'
import { useDispatch, useSelector } from 'react-redux';
import { loadCreditsData, logoutFunction } from '../redux/action';
import * as HeaderAuthentication from '../HeaderAuthentication';

const AppNavbar = () => {
    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const expiryStatus = useSelector((state) => state.expiryStatus);

    const roles = signInDetails[0]?.role;

    const { getCredits } = useSelector(state => state.data);

    const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);

    const [modalShow, setModalShow] = useState(false);

    useEffect(() => {
        dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id))
    }, [])

    const handleToggle = (e) => {
        setShowSettingsDropdown((prev) => !prev);
        setShowProfileDropdown(false);
    };

    const handleProfileToggle = (e) => {
        setShowProfileDropdown(prev => !prev);
        setShowSettingsDropdown(false);
    };

    const logOutPage = () => {
        const logout_body = {
            "user_id": parseInt(signInDetails[0]?.id),
            "session_id": signInDetails[0]?.session_id
        }
        const logout_post = {
            method: 'POST',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(logout_body),
        }
        dispatch(logoutFunction(logout_post));
    }
    const handleModalClose = () => {
        setModalShow(false);
    }
    const openLoguutModal = () => {
        setModalShow(true);
    }
    const [isFullScreen, setIsFullScreen] = useState(false);
    const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => setIsFullScreen(true));
    } else {
      document.exitFullscreen().then(() => setIsFullScreen(false));
    }
  };


    return (
        <>
            <Navbar expand="lg" className="navabar-container">
                <Container fluid>
                    <Navbar.Brand><img src={companyLogo} alt="" /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbarScroll" />
                    <Navbar.Collapse id="navbarScroll" className='nav-collapse'>
                        <Nav
                            className="nav-collapse-first-div"
                            style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            <Nav.Link href="/dashboard">Home</Nav.Link>
                            <NavDropdown title="Search" id="navbarScrollingDropdown">
                                <NavDropdown.Item href="/contact-filter">
                                    Contacts
                                </NavDropdown.Item>
                                {roles?.toLowerCase() !== "b2buser" && (
                                    <>
                                        <NavDropdown.Item href="/saved-searches">
                                            Saved Searches
                                        </NavDropdown.Item>
                                        <NavDropdown.Item href="/viewed-contacts">
                                            Viewed Contacts
                                        </NavDropdown.Item>
                                    </>
                                )}
                                
                            </NavDropdown>
                            {roles?.toLowerCase() === "super_admin" && (<NavDropdown title="Report" id="navbarScrollingDropdown">
                                <NavDropdown.Item href="/upload-reports">
                                    Upload Report
                                </NavDropdown.Item>
                                <NavDropdown.Item href="/data-count">
                                    Data Count
                                </NavDropdown.Item>
                            </NavDropdown>)}
                            {(roles?.toLowerCase() === "admin" || roles?.toLowerCase() === "user") && (
                                <Nav.Link href="/my-list">My List</Nav.Link>
                            )}
                            <Nav.Link href="/raiserequest">RaiseRequest</Nav.Link>
                        </Nav>

                    
                       
                        <div className='nav-collapse-second-div'>
                            <p className='credits-count'>{getCredits.credits_aval} credits Left</p>
                            <i className={`bx ${isFullScreen ? "bx-exit-fullscreen" : "bx-fullscreen"} fl-icon`}
                                onClick={toggleFullScreen}
                                style={{ cursor: "pointer", fontSize: "20px" }}
                                title={isFullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                            ></i>
                            
                            <Nav.Link onClick={handleToggle} className='settings-nav-link'>
                                <i className='fa fa-gear settings-icon' />
                            </Nav.Link>
                            <NavDropdown
                                title=""
                                id="navbarScrollingDropdown"
                                className='settingsNavDropdown'
                                show={showSettingsDropdown}
                                onMouseLeave={() => setShowSettingsDropdown(false)} 
                            >
                                {(roles?.toLowerCase() === "super_admin" || roles?.toLowerCase() === "b2buser") && (<NavDropdown.Item href="/upload-csv">
                                    <i className='bx bx-cloud-upload text-muted fs-16 align-middle me-1'></i>Upload CSV</NavDropdown.Item>)}
                                {roles?.toLowerCase() !== "b2buser" && (
                                    <>
                                        <NavDropdown.Item href="/trash">
                                        <i className='fa fa-edit text-muted fs-16 align-middle me-1'></i>
                                        Trash
                                        </NavDropdown.Item>
                                        <NavDropdown.Item href="/users">
                                        <i className='bx bxs-user-account text-muted fs-16 align-middle me-1'></i>
                                        Users
                                        </NavDropdown.Item>
                                    </>
                                )}
                            </NavDropdown>

                            <Nav.Link onClick={handleProfileToggle} className="p-0">
                                <div className='header-profile-div' style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                    <img
                                        src={profileImg}
                                        alt="Profile"
                                        style={{ height: "30px", width: '30px', borderRadius: '50%', marginRight: '10px' }}
                                    />
                                    <div className='header-user-name'>
                                        <span>{signInDetails[0]?.name} - ({roles})</span>
                                        <p style={{ margin: 0 }}>{signInDetails[0]?.email}</p>
                                    </div>
                                </div>
                            </Nav.Link>

                            {/* NavDropdown shown manually */}
                            <NavDropdown
                                title=""
                                id="profileDropdown"
                                className="settingsNavDropdown"
                                show={showProfileDropdown}
                                onMouseLeave={() => setShowProfileDropdown(false)}
                            >
                                <NavDropdown.Item href="/profile"><i className="fas fa-user fs-16 me-1"></i>Profile</NavDropdown.Item>
                                <NavDropdown.Item href="/reset-password"><i className="fas fa-key fs-16 me-1"></i>Change Password</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item onClick={openLoguutModal}><i className="fas fa-sign-out-alt fs-16 me-1"></i>Logout</NavDropdown.Item>
                            </NavDropdown>
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* Logout modal */}
            <Modal show={modalShow} onHide={handleModalClose}
                className='saved-search-modal'>
                <Modal.Body>
                    <div>
                        <img src={logOutImg} alt="" className='logout_img' />
                        <h6 className='logout_text'>Are you sure you want to log out? We'll be right here when you get back.</h6>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <ClearBtn btnName='No, Stay' onClickEffect={handleModalClose} />
                    <SearchBtn btnName='Yes, Logout' onClickEffect={logOutPage} />
                </Modal.Footer>
            </Modal>
            {/* Logout modal */}
        </>
    );
};

export default AppNavbar;
